import type { Theme } from "@mui/material";

const MuiInputLabel = (theme: Theme) => ({
  styleOverrides: {
    root: {
      "&.Mui-focused": {
        color: theme.palette.primary.main,
      },
    },
  },
});

export default MuiInputLabel;
